export const enHome = {
  greetingMorning: "Good morning, {{name}}",
  greetingAfternoon: "Good afternoon, {{name}}",
  greetingEvening: "Good evening, {{name}}",
  greetingMorningAnonymous: "Good morning",
  greetingAfternoonAnonymous: "Good afternoon",
  greetingEveningAnonymous: "Good evening",
  subtitle: "Welcome to your insights platform",
  askOlive: "Ask Olive",
  favoriteApps: {
    title: "Favorite Apps",
    viewAll: "View All",
    empty: "No favorite apps yet.",
    loadFailed: "Could not load favorite apps. Please try again.",
    listAriaLabel: "Favorite apps",
    unknownCategory: "Uncategorized",
    sectionToggleAriaLabel: "Toggle {{title}} section",
  },
  latestNuggets: {
    title: "New Nuggets",
    loadMore: "Load More",
    empty: "No nuggets yet.",
    loadFailed: "Could not load nuggets. Please try again.",
    listAriaLabel: "New nuggets",
    insightsLabel: "Insights:",
  },
} as const;
